import * as React from 'react';
import { Link } from 'react-router-dom';
import { RootState } from 'src/reducers/RootReducer';
import { connect } from 'react-redux';

interface StateProps {
  location: string | null;
}

interface Props extends StateProps {
  pageTitle: string;
  breadcrum?: string;
  showSubTitle?: boolean;
}

class MyAccountHeaderComponent extends React.Component<Props> {

  public render(): React.ReactNode {

    const path = this.props.location!.toString();

    return (
      <section>
        <div className="row">
          <div className="col-md-8">
            <h1 className="bold-title">
              {this.props.pageTitle}
            </h1>
            <div className="gap-20" />
          </div>
          <div className="col-md-4">
            <p className="breadcrumb text-right">
              Inicio > Mi cuenta {this.props.breadcrum ? '> ' + this.props.breadcrum : null}
            </p>
          </div>
        </div>
        <div className="row myaccount">
          <div className="col-lg-10 col-lg-offset-1 text-center">
            <div className="c-grey f-s-16">
              <span className="sep">
                /
                </span>
              <span className="user-circle" />
              <Link to="/mi-cuenta/perfil">
                {path.includes('perfil') ?
                  <strong className="italic">
                    Mi perfil
                  </strong> :
                  'Mi perfil'
                }
              </Link>
              <span className="sep">
                /
                </span>
              <span className="user-circle" />
              <Link to="/mi-cuenta/tipo-de-inversor">
                {path.includes('tipo-de-inversor') ?
                  <strong className="italic">
                    Tipo de inversor
                  </strong> :
                  'Tipo de inversor'
                }
              </Link>
              <span className="sep">
                /
                </span>
              <span className="pass" />
              <Link to="/mi-cuenta/cambiar-contrasena">
                {path.includes('cambiar-contrasena') ?
                  <strong className="italic">
                    Cambiar contraseña
                  </strong> :
                  'Cambiar contraseña'
                }
              </Link>
              <span className="sep">
                /
                </span>
              {/*TODO*/}
              {/*<span className="security"/>
              <Link to="/mi-cuenta/seguridad-en-dos-pasos">
                {path.includes('seguridad-en-dos-pasos') ?
                  <strong className="italic">
                    Seguridad en dos pasos
                  </strong> :
                  'Seguridad en dos pasos'
                }
              </Link>
              <span className="sep">
                  /
                </span>*/}
            </div>
            <div className="gap-40" />
          </div>
        </div>
        {this.props.showSubTitle ?
          <div className="row">
            <p className="featured c-black-text">
              <span className="user-circle" />
              Selecciona tu perfil de inversión
          </p>
            <div className="gap-30" />
          </div> :
          null
        }

      </section>
    );
  }
}

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  location: state.router.location ? state.router.location.pathname : '',
});

export default connect(mapStateToProps)(MyAccountHeaderComponent);


// WEBPACK FOOTER //
// ./src/modules/my-account/partials/MyAccountHeader.component.tsx